import {
  getData,
  postData,
  putData,
  editStatusData,
  deleteData,
  getDownloadDataExcel,
} from "../../api";

export const Register = async (data) => {
  try {
    console.log(data);

    const res = await postData(`/common/auth/user-singup`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const Login = async (data) => {
  try {
    const res = await postData(`/common/auth/user-login`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const forgetPassword = async (data) => {
  try {
    const res = await postData(`/common/auth/forgot-password`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};

export const updateIdentityImage = async (data) => {
  try {
    const res = await postData(`/common/auth/update-profile-photo`, data);

    return res;
  } catch (error) {
    console.log(error);
  }
};
